<template>
  <div>
    <b-container fluid="xl">
      <b-row class="justify-content-end">
        <b-col
          md="6"
          cols="10"
          class="overflow-hidden vh-100 d-none d-md-block mr-auto bg-login"
        >
          <img :src="`${publicPath}/img/gep/img-login.svg`" class="img-login" />
          <div class="top-text">
            <div class="fz-28 fw-700">
              {{ $t("Welcome to RCPAY Virtual Account") }}
            </div>
            <div class="fz-28 fw-700">
              {{ $t("Simplifying Your Banking Experience") }}
            </div>
            <!-- <div class="fz-16 fw-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> -->
          </div>
          <div class="bottom-text">
            <!-- <div class="fz-31 fw-700">Welcome to<br />RC365 V Bank</div> -->
            <div class="fz-10 fw-400 mb-1">
              RCPAY Limited is incorporated in the United Kingdom with company
              registration number 12026575.
            </div>
            <div class="fz-10 fw-400">
              RCPAY Limited is the FCA regulated licensed company with license
              number: 917656
            </div>
          </div>
        </b-col>
        <b-col md="4" cols="10" class="minh-100 px-0 mx-auto">
          <div class="d-flex flex-column h-100 justify-content-center">
            <div class="mb-3">
              <div class="fz-31 fw-700 mb-1">{{ $t('Forget Password?') }}</div>
              <div class="text-muted fz-16 fw-400">{{ $t('Please enter email address associated with your account!') }}</div>
            </div>
            <hr/>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(onSubmit)" id="formLogin">
                <div class="mb-3">
                  <base-input alternative
                      class="mb-0"
                      name="Email"
                      :placeholder="$t('Email')"
                      v-model="email"
                      @keydown="onChange">
                    <template v-slot:prepend><img :src="`${publicPath}/img/rcp/icon/mdi_email.png`"></template>
                  </base-input>
                  <div v-if="error.email" class="invalid-feedback d-block mb-3">
                    {{error.email}}
                  </div>
                </div>

                <div class="text-center mb-4">
                  <base-button type="primary" pill native-type="submit" class="my-4">{{ $t('Forget Password') }}</base-button>
                </div>
              </b-form>
            </validation-observer>
            <div v-if="translation==1" class="change_lang p-4 text-center" id="language">
              <span v-for="(item,index) in language_list" v-if="index!='my-MY'" :key="index">
                <a @click.stop.prevent="setLanguage(index)" :class="'fz-14 '+((current_lang==index)?'active':'')">{{ item }}</a>
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import Auth from "@/services/Auth";
  import LoaderComponent from "@/components/LoaderComponent";
  import Common from "@/services/Common";

  export default {
    data() {
      return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        translation     : process.env.VUE_APP_TRANSLATION,
        company_logo        : '',
        list_logo           : JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
        email       : '',
        language_list : [],
        current_lang : '',
        isLoading   : false,
        error:{
          email     : ''
        }
      };
    },
    components:{LoaderComponent},
    methods: {
      setLanguage(param){
        localStorage.setItem("lang",param);
        localStorage.setItem("lang-key",param);
        
        const self = this;
        self.$notify({type: 'success', text: self.getMessage('Successfully change default language')});

        setTimeout(function(){
          location.reload();
        },500);
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      onChange:function(){
        Object.keys(this.error).forEach((key)=>{
          this.error[key] = '';
        });
      },
      onSubmit: async function() {
        this.isLoading = true;
        const data = { email: this.email };
        const self = this;
        
        await Auth.forget(data).then(response => {
          if(response.status == 200 && response.data.success){
              this.isLoading = false;
              const data = response.data;
              this.$swal({
                icon : 'success',
                title: self.getMessage('EMAIL SENT'),
                html : response.data.message,
                showConfirmButton: true,
              }).then((result) => {
                this.$router.push({ path: '/login' });
              });
            }
        })
        .catch(err => {
          this.isLoading = false;
          const response = err.response;
          if(response.status == 400){
            this.error.email = response.data.message;
          }
        });
      }
    },
    mounted () {
      Object.keys(this.list_logo).forEach((key) => {
        if(window.location.hostname.indexOf(key)!=-1){
          this.company_logo = this.list_logo[key];
        }
      });

      if(this.translation==1){  
        this.current_lang = localStorage.getItem("lang-key");
        Common.get_language().then(response => {
          if(response.status == 200 && response.data.success){
            this.language_list = response.data.data;
          }
        });
      }
    }
  };
</script>
